import { mapGetters } from 'vuex';

export default {
  name: 'Titles',
  props: {
    title: {
      type: String,
      default: '',
    },
    showProductName: {
      type: Boolean,
      default: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    showSubtitle: {
      type: Boolean,
      default: true,
    },
    partNumber: {
      type: String,
      default: '',
    },
    showPartNumber: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      partNumberTitle: 'getPartNumberTitle',
    }),
  },
};
